<template>
  <v-navigation-drawer app
    :fixed="drawerState"
    :mini-variant="!drawerState"
    :permanent="!$vuetify.breakpoint.smAndDown"
  >
    <div class="mt-14"></div>
    <div class="mt-14"></div>

    <v-list nav shaped>
      <v-list-item-group
        v-model="selectedItem"
        color="primary"
      >
        <v-list-item v-for="item in filteredNavigations" :key="item.name"      @click="onNavigationClick(item)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon> {{ item.icon }} </v-icon>
              </v-list-item-icon>
              <v-list-item-title> {{ item.name }} </v-list-item-title>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-spacer></v-spacer>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavigationDrawer',
  props: {
    drawer: Boolean
  },
  data () {
    return {
      selectedItem: null,
      navigations: [
        { name: 'Home', link: '/', icon: 'mdi-home', type: 'link' },
        { name: 'About', link: '/about', icon: 'mdi-information', type: 'link' },
        { name: 'Migrations', link: '/migrations', icon: 'mdi-transfer', type: 'link' },
        { name: 'Metrics', link: '/metrics', icon: 'mdi-chart-bar', type: 'link' },
        { name: 'Help', link: '', icon: 'mdi-help-circle', type: 'button' }
      ]
    }
  },
  methods: {
    onNavigationClick (item) {
      if (item.type === 'link') {
        this.$router.push(item.link)
      } else {
        this.$emit('toggle-help-dialog')
      }
    }
  },
  computed: {
    filteredNavigations () {
      return this.navigations.filter(item => {
        if (item.name === 'Migrations') {
          return this.$userInfo.profile && this.$userInfo.profile.isAdmin
        }
        return true
      })
    },
    drawerState: {
      get () {
        return this.drawer
      },
      set (value) {
        this.$emit('update:drawer', value)
      }
    }
  },
  watch: {
    drawer: {
      handler (value) {
        // console.log('drawer', value)
        this.drawerState = value
      },
      immediate: true
    }
  }
}
</script>
